import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://6b485d0c4312e74388148a8ff3746105@o4509506447933440.ingest.us.sentry.io/4509506449244160",
  sendDefaultPii: true
});

createRoot(document.getElementById("root")!).render(<App />);
